<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['confirmed']);

const store = useStore();
const dialogRef = ref(null);
const campaignToReprocess = ref(null);
const title = 'Reprocessar campanha?';
const description =
  'Todos os disparos serão enviados novamente. Ao confirmar, os contadores da campanha serão zerados antes do novo envio.';
const confirmButtonLabel = 'Reprocessar campanha';
const alertMessage =
  'Confirme apenas se deseja reenviar a campanha para todos os destinatários.';

const open = campaign => {
  campaignToReprocess.value = campaign;
  dialogRef.value?.open();
};

const closeDialog = () => {
  dialogRef.value?.close();
  campaignToReprocess.value = null;
};

const handleDialogConfirm = async () => {
  const campaignId = campaignToReprocess.value?.id;
  closeDialog();
  if (!campaignId) return;

  try {
    await store.dispatch('campaigns/reprocess', campaignId);
    await store.dispatch('campaigns/get');
    useAlert('Campanha enviada para reprocessamento.');
    emit('confirmed');
  } catch {
    useAlert('Não foi possível reprocessar a campanha.');
  }
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="title"
    :description="description"
    :confirm-button-label="confirmButtonLabel"
    @confirm="handleDialogConfirm"
  >
    <div
      class="rounded-lg border border-n-amber-7 bg-n-amber-3 p-3 text-sm text-n-amber-12"
    >
      {{ alertMessage }}
    </div>
  </Dialog>
</template>
